import { useMutation, useQueryClient } from "@tanstack/react-query"
import { toggleIntention } from "../services/intention.service"

export function useToggleIntention(slug: string) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (intentionId: string) => toggleIntention(intentionId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["intention", slug] })
      queryClient.invalidateQueries({ queryKey: ["intentions"] })
    },
  })
}
